import { SearchFilterTag } from '@/components';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import { ProjectCategoryLabelModifier } from '@/utils/enum';
import type { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const CategoriesTag: FC = () => {
  const { t } = useTranslation();

  const { control, setValue } = useFormContext<ProjectSearchFormType>();

  const sheetType = useWatch({
    control,
    name: 'sheetType',
  });

  const categories = useWatch({
    control,
    name: 'categories',
  });

  if (sheetType === 'KS' || !categories?.length) {
    return null;
  }

  const value =
    categories?.map((item) => ProjectCategoryLabelModifier[item])?.join(', ') ??
    '';

  return (
    <SearchFilterTag
      closable={true}
      label={`${t('project-category')}: ${value}`}
      onClose={() => {
        setValue('categories', null);
      }}
    />
  );
};
